(function () {
  'use strict';

  function equalize(root) {
    var slides = (root || document).querySelectorAll('.reasons .reasons__card');
    if (!slides.length) return;

    slides.forEach(function (slide) {
      slide.style.height = '';
    });

    if (window.matchMedia('(min-width: 750px)').matches) return;

    var max = 0;
    slides.forEach(function (slide) {
      max = Math.max(max, slide.offsetHeight);
    });
    if (max > 0) {
      slides.forEach(function (slide) {
        slide.style.height = max + 'px';
      });
    }
  }

  function hook(el) {
    if (!el || el._reasonsHooked) return;
    var started = Date.now();
    var tick = function () {
      if (el.slider) {
        el._reasonsHooked = true;
        equalize(el);
        el.slider.on('resize', function () {
          equalize(el);
        });
        el.slider.on('breakpoint', function () {
          equalize(el);
        });
        return;
      }
      if (Date.now() - started < 4000) window.requestAnimationFrame(tick);
    };
    tick();
  }

  function boot() {
    document.querySelectorAll('.reasons slider-component[data-slider="true"]').forEach(function (el) {
      el._reasonsHooked = false;
      if (el._sliderInitObserver) {
        try {
          el._sliderInitObserver.disconnect();
        } catch (e) {}
      }
      if (el.slider && typeof el.slider.destroy === 'function') {
        try {
          el.slider.destroy(true, true);
        } catch (e) {}
        el.slider = undefined;
      }
      var start = function () {
        if (window.matchMedia('(min-width: 750px)').matches) return;
        if (typeof el.initSlider === 'function') el.initSlider();
        hook(el);
      };
      if (typeof window.ensureThemeSwiper === 'function') {
        window
          .ensureThemeSwiper()
          .then(start)
          .catch(function () {});
      } else {
        start();
      }
    });
  }

  window.refreshReasonsCarousel = boot;

  function onReady() {
    boot();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  window.matchMedia('(min-width: 750px)').addEventListener('change', boot);
  document.addEventListener('shopify:section:load', boot);
})();
